import { render, staticRenderFns } from "./OrderTab.vue?vue&type=template&id=69e2c725&"
import script from "./OrderTab.vue?vue&type=script&lang=js&"
export * from "./OrderTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports